module.exports = __webpack_public_path__ + "static/img/04.8d42960a.png";